export default __webpack_public_path__ + "static/media/Products.6aed79cf.svg";